<template>
    <base-modal
        size="xl"
        hide-footer
        hide-header
        prevent-close
        no-padding
    >
        <div class="order-route-simulation-container">
            <route-optimization-simulation
                :use-store="false"
                :route-data="preparedRouteData"
                @go-back="$emit('close')"
            />
        </div>
    </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import RouteOptimizationSimulation from '@/components/routeoptimization/RouteOptimizationSimulation.vue'

const VEHICLE_COLORS = [
    "#7FC200", "#2196F3", "#FF8C00", "#FF6B6B", "#4ECDC4",
    "#45B7D1", "#FFA07A", "#98D8C8", "#F7DC6F"
]

export default {
    name: 'OrderRouteMapModal',
    components: { BaseModal, RouteOptimizationSimulation },
    props: {
        orderRoutes: {
            type: Array,
            required: true
        }
    },
    emits: ['close'],
    computed: {
        preparedRouteData() {
            return this.orderRoutes.map((route, index) => {
                const routeData = route.route_data || route
                const geojson = routeData.geojson
                    ? JSON.parse(JSON.stringify(routeData.geojson))
                    : JSON.parse(JSON.stringify(routeData))
                const metadata = { ...(routeData.metadata || {}) }

                metadata.vehicleColor = VEHICLE_COLORS[index % VEHICLE_COLORS.length]

                if (geojson && geojson.features) {
                    geojson.features.forEach(feature => {
                        if (feature.properties) {
                            feature.properties.traversal_type =
                                feature.properties.priority > -1 ? 'work' : 'resettle'
                        }
                    })
                }

                return {
                    geojson,
                    metadata,
                    label: metadata.vehicleName
                        ? `${metadata.vehicleName}`
                        : `Route ${index + 1}`
                }
            })
        }
    }
}
</script>

<style scoped>
.order-route-simulation-container {
    height: 80vh;
    position: relative;
}

.order-route-simulation-container :deep(.route-simulation-view) {
    height: 100%;
}
</style>
